import React, { FC, useCallback, useEffect, useState } from 'react';
import { Button, Placeholder, ScrollView } from '$uikit';
import { useDispatch, useSelector } from 'react-redux';
import { toastActions } from '$store/toast';
import { Api } from '$api';
import { mainSelector } from '$store/main';
import { useTranslator } from '$hooks';
import { IcSuccess72 } from '$assets';
import { Link } from 'react-router5';
import { FEED } from '$shared/constants/pages';
import { hasIn } from 'lodash';
import { Loader } from '$shared/components';
import { authSelector } from '$store/auth';
import { AuthRequired } from '$core/AuthRequired/AuthRequired';

export const ShowSubscription: FC = () => {
  const t = useTranslator();
  const { decryptKeys } = useSelector(mainSelector);
  const hasSubscription = decryptKeys[-1];
  const [link, setLink] = useState('');
  const { isLogged } = useSelector(authSelector);

  const handleLoad = useCallback(() => {
    Api.get<any, any>('/telegram/show')
      .then((resp) => {
        setLink(resp.url);
      })
      .catch(() => {
        setTimeout(() => handleLoad(), 3000);
      });
  }, []);

  useEffect(() => {
    if (!hasSubscription && isLogged) {
      handleLoad();
    }
  }, []);

  if (!isLogged) {
    return <AuthRequired />;
  }

  if (hasSubscription) {
    return (
      <Placeholder
        centered
        title={t('subscription_success_title')}
        icon={<IcSuccess72 />}
        actions={
          <Link routeName={FEED}>
            <Button>{t('subscription_success_button_go_to_feed')}</Button>
          </Link>
        }
      >
        {t('subscription_success_adult_caption')}
      </Placeholder>
    );
  }

  if (!link) {
    return <Loader isWrapped />;
  }

  return (
    <ScrollView>
      <Placeholder
        iconSize={82}
        icon={
          <div
            style={{
              width: 82,
              height: 82,
              borderRadius: '50%',
              flex: '0 0 auto',
              background: `no-repeat center/cover url(${
                require('$assets/art/show_logo.jpeg').default
              })`,
            }}
          />
        }
        centered
        title="Ton.Place Show Private"
        actions={
          <Button href={link} target="_blank">
            {t('show_subscription_btn')}
          </Button>
        }
      >
        {t('show_subscription_text')}
      </Placeholder>
    </ScrollView>
  );
};
